import styled from '@emotion/styled';

import Box from 'app/components/v2/components/Box';
import styles from 'app/components/v2/constants/styles';

// Local Typings
export interface StyledNavProps {
  isClosedOnMobile: boolean;
  topNavHeight: number;
}

// Local Variables
export const StyledNav = styled.nav<StyledNavProps>(props => ({
  backgroundColor: props.theme.semanticColors.sidenav_background,
  borderRight: `2px solid ${props.theme.semanticColors.nav_border}`,
  display: 'flex',
  height: '100%',

  [props.theme.components.mediaQueries.sm.max]: {
    bottom: 0,
    height: 'auto',
    left: props.isClosedOnMobile ? -2 : 0, // account for border
    position: 'fixed',
    top: props.topNavHeight,
    zIndex: styles.zIndex.nav - 1,
  },

  [props.theme.components.mediaQueries.xs.max]: {
    top: props.topNavHeight,
    zIndex: styles.zIndex.nav + 1,
  },
}));
export const Container = styled(Box)<{ width: string }>(props => ({
  maxWidth: props.width,
  overflowX: 'hidden',
  transition: '300ms',
}));
export const StyledList = styled.ul<{ width: number | string }>(({ theme, width }) => ({
  alignItems: 'stretch',
  display: 'flex',
  flexDirection: 'column',
  paddingBottom: theme.spacing * 8,
  paddingTop: theme.spacing * 8,
  width,
}));
